module.exports = __webpack_public_path__ + "aa829f2a7902ec82b31765ed38dc8da8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-shapes/images/heart@2x.png
// module id = 306
// module chunks = 0